// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"1278cf78","453":"e99ec615","527":"69c0063c","909":"6598e8df"}[chunkId] + ".chunk.js";
};